'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  organizations: {
    empty: 'No organization found.',
    form: {
      confirmSave: ' Do you want to save the changes made in this organization\xA0?',
      dontSave: 'Do not save',
      parentOrganization: 'Parent organization',
      save: 'Save'
    },
    new: 'Add organization',
    next: 'Next page',
    previous: 'Previous page',
    sortDirection: {
      asc: 'Ascending',
      desc: 'Descending'
    },
    sortOrder: {
      creation: 'Created at',
      modification: 'Modified at',
      name: 'Name'
    },
    subOrganizationOf: 'Sub organization of ',
    title: 'Organizations',
    titleBox: {
      help: 'Name of organization'
    },
    total: '%{smart_count} organization ordered by |||| %{smart_count} organizations ordered by'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/organizations.js
// module id = 2285
// module chunks = 0